export default __webpack_public_path__ + "static/Golf-60cb9df9fa759ceba76a210bd39edf8d.jpg";